export const API_BASE = "https://unifiedcalendar.xyz";
// "http://unifiedcal-env.eba-jahz822d.eu-north-1.elasticbeanstalk.com";
// "https://unifiedcalendar.xyz";
const API_KEY = process.env.REACT_APP_API_KEY;

export const fetchPartners = async () => {
  const res = await fetch(`${API_BASE}/partners`, {
    headers: {
      'x-api-key': API_KEY
    }
  });
  if (!res.ok) throw new Error("Failed to fetch partners");
  return res.json();
};

export const fetchAvailability = async (grantId, email, start, end) => {
  const url = `${API_BASE}/partnerSlots/availability/${grantId}?email=${email}&start=${start}&end=${end}`;
  
  const res = await fetch(url, {
    headers: {
      'x-api-key': API_KEY
    }
  });
  
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to fetch slots: ${errorText}`);
  }
  
  const data = await res.json();
  return data.timeSlots || []; 
};

export const bookMeeting = async (payload) => {
  const guestArray = Array.isArray(payload.guestEmails) 
    ? payload.guestEmails 
    : payload.guestEmails
        .split(",")
        .map(email => email.trim())
        .filter(email => email.length > 0);

  const res = await fetch(`${API_BASE}/bookSlot`, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "Accept": "application/json",
      "x-api-key": API_KEY
    },
    body: JSON.stringify({
      partnerGrantId: payload.partnerGrantId,
      userEmail: payload.userEmail, 
      guestEmails: guestArray,
      startTime: payload.startTime,
      endTime: payload.endTime,
      title: payload.title,
      description: payload.description || "Technical Partner Session"
    }),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || `Server responded with ${res.status}`);
  }

  return res.json();
};